<div class="layout-wrapper h-full flex flex-col">
  <app-public-layout-header></app-public-layout-header>
  <div class="flex-1 min-h-0">
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast position="bottom-center" key="bc" />
